import { canAccessAdminShell, canManageDevices, isAdministrator } from '@versports/access'
import type { MeResponse } from '../api/auth'

export function canSeeAdmin(user: MeResponse | null | undefined): boolean {
  return isAdministrator(user)
}

export function canConfigureDevices(user: MeResponse | null | undefined): boolean {
  return canManageDevices(user)
}

export function canSeeAdminShell(user: MeResponse | null | undefined): boolean {
  return canAccessAdminShell(user)
}
